/** Query key for a file's share links; targeted by the mint/revoke mutations. */
export function SHARES_QUERY_KEY(fileId: string) {
  return ["fileApi", "shares", fileId];
}
